export default "__VITE_ASSET__BlnXfmAo__"